var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.999,
    viewBox: "0 0 20 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23472",
    "data-name": "Path 23472",
    d: "M-7675.894-2381.552l-1.224-2.447h-5.764l-1.225,2.447a1,1,0,0,1-.9.552,1.016,1.016,0,0,1-.444-.1,1,1,0,0,1-.448-1.342l1.493-2.985a.188.188,0,0,1,.014-.027l3.493-6.988a1,1,0,0,1,.9-.552,1,1,0,0,1,.894.552l3.493,6.988a.1.1,0,0,1,.013.027l1.493,2.985a1,1,0,0,1-.446,1.342,1.007,1.007,0,0,1-.448.1A1,1,0,0,1-7675.894-2381.552Zm-5.988-4.447h3.766l-1.883-3.763Zm-12.015,1.574a1,1,0,0,1,.452-1.34,17.057,17.057,0,0,0,5.156-3.949,18.994,18.994,0,0,1-2.221-3.9,1,1,0,0,1,.531-1.309,1,1,0,0,1,1.311.531,17.17,17.17,0,0,0,1.665,3.034,16.966,16.966,0,0,0,2.53-5.644H-7693a1,1,0,0,1-1-1,1,1,0,0,1,1-1h5v-1a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1h5a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.423a18.922,18.922,0,0,1-3.294,7.282c.158.177.319.351.485.523a1,1,0,0,1-.025,1.416.993.993,0,0,1-.695.28,1,1,0,0,1-.718-.3c-.112-.118-.222-.234-.333-.354a19.009,19.009,0,0,1-5.551,4.183.994.994,0,0,1-.444.1A1,1,0,0,1-7693.9-2384.426Z",
    transform: "translate(7694 2400.999)",
    fill: "#474a4e",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageLight);
export default __webpack_public_path__ + "static/media/LanguageLight.ea36a3d1b118817e5eaf6079f238a452.svg";
export { ForwardRef as ReactComponent };